/**
 * Only show "See how to save" if the vehicle has savings available and the savings are positive.
 */
export function shouldShowSeeHowToSave(savingsAvailable?: boolean, savings?: number) {
  return savingsAvailable && savings !== undefined && savings > 0;
}
